export default {"src":"/_next/static/media/Paint.626b7159.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};